export default __webpack_public_path__ + "maps-guides-styles-layers-line-layer-1200-2f6decb6140f0c707b19d60d0e5b64df.png";